module.exports = __webpack_public_path__ + "img/news.48cace51.png";